/**
 * Render a backend decimal string as the shortest true form of itself:
 * "31.50" → "31.5", "0.00" → "0", "2.25" → "2.25".
 *
 * String surgery rather than `Number()` on purpose. These values are money-like
 * quantities the agency chose deliberately; round-tripping them through a float
 * to prettify them is how a "2.10" becomes a "2.1000000000000001" in some
 * future locale or precision change. Trailing zeros are the only thing removed,
 * and anything that is not a plain decimal is passed through untouched rather
 * than mangled.
 */
export const formatPointsValue = (value: string): string => {
  if (!/^-?\d+\.\d+$/.test(value)) return value;
  return value.replace(/\.?0+$/, '');
};

/**
 * "6 tasks" / "1 task". Small, but the alternative ships "1 tasks" to a
 * clinician on the one row where they are carrying a single visit.
 */
export const pluralizeTasks = (count: number): string =>
  `${count} ${count === 1 ? 'task' : 'tasks'}`;
